import { useCallback, useState } from 'react';

import { OrderService } from '@lib/api';
import { isApiError } from '@lib/api/client';
import { type ApplicationState, useApplicationState } from '@lib/state';

const selectOrder = (s: ApplicationState) => s.order;

export const useOrder = () => {
    const state = useApplicationState(selectOrder);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);

    const getOrderDetail = useCallback(
        async (orderId: number) => {
            try {
                setIsLoadingDetail(true);
                // First check in previous orders
                const existingOrder = state.previousOrders.find(
                    (o) => o.order_id === Number(orderId)
                );
                if (existingOrder) {
                    return existingOrder;
                }

                // Fetch from API if not found
                const response = await OrderService.getOrderDetail(orderId);
                if (isApiError(response)) {
                    return;
                }

                return response;
            } catch (error) {
                console.error('Error fetching order detail:', error);
                return;
            } finally {
                setIsLoadingDetail(false);
            }
        },
        [state.previousOrders]
    );

    return {
        ...state,
        getOrderDetail,
        isLoadingDetail
    };
};

export default useOrder;
